import React from 'react'
import { useLocation } from 'react-router'
import { useHeader } from 'pages/NewDashboard/hooks/useHeader'
import NoLongerSupport from 'pages/NewDashboard/components/Header/NoLongerSupport'
import { HeaderStyles } from './styles'
import TopHeader from './TopHeader'
import VerticalHeader from './VerticalHeader'

const Header = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  const classes = HeaderStyles()
  const { loading, ready, loadingBusinessConfig } = useHeader()

  const isToShowNoLongerSupport = () => {
    return location.pathname.includes('billing') || location.pathname.includes('ledger')
  }
  return (
    <div className={classes.headerContainer}>
      <TopHeader />
      {/* {!isToShowNoLongerSupport() ? <NoLongerSupport /> : null} */}
      <div className={classes.verticalHeaderContainer}>
        <VerticalHeader />
        <div className={classes.childrenContainer}>
          {!loading && ready && !loadingBusinessConfig && children}
        </div>
      </div>
    </div>
  )
}

export default Header
